import { fetchLocations } from '@/lib/request/fetchLocations';
import type { Locations } from '@/lib/request/types/location';
import { defineStore } from 'pinia';

export interface LocationStoreStatus {
  isLoading: boolean;
}

export interface LocationStoreErrors {
  loadingError: Error | null;
}

export interface LocationStore {
  data: Locations;
  status: LocationStoreStatus;
  errors: LocationStoreErrors;
}

export const useLocationStore = defineStore({
  id: 'location',
  state: (): LocationStore => ({
    data: [],
    status: {
      isLoading: false,
    },
    errors: {
      loadingError: null,
    },
  }),
  actions: {
    async load() {
      this.errors.loadingError = null;
      this.status.isLoading = true;
      try {
        this.data = await fetchLocations();
      } catch (e) {
        if (e instanceof Error) {
          this.errors.loadingError = e;
          throw e;
        }
      } finally {
        this.status.isLoading = false;
      }
    },
  },
});
